import { Button } from "@/components/ui/button";
import { ArrowLeft, CalendarIcon } from "lucide-react";
import { Customer } from "@/hooks/useCustomers";
import { VisitFormContent, VisitFormData } from "./VisitFormContent";

interface VisitFormViewProps {
  title: string;
  values: VisitFormData;
  onFieldChange: (field: keyof VisitFormData, value: any) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading: boolean;
  showDeleteButton?: boolean;
  onDelete?: () => void;
  showNoShowButton?: boolean;
  onNoShow?: () => void;
  currentStatus?: string | null;
  selectedCustomer?: Customer | null;
  onCustomerSelect?: (customer: Customer | null) => void;
  visitServiceIds: string[];
  visitTeamMemberIds: string[];
  onVisitChange: (serviceIds: string[], teamMemberIds: string[]) => void;
  filteredTeamMemberIds?: string[];
  prefilledCustomer?: Customer;
  isEditingVisit?: boolean;
}

export const VisitFormView = ({
  title,
  values,
  onFieldChange,
  onSubmit,
  onCancel,
  isLoading,
  showDeleteButton = false,
  onDelete,
  showNoShowButton = false,
  onNoShow,
  currentStatus = null,
  onCustomerSelect = () => { },
  visitServiceIds,
  visitTeamMemberIds,
  onVisitChange,
  prefilledCustomer,
  isEditingVisit = false
}: VisitFormViewProps) => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-background">
      {/* Header */}
      <div className="bg-card border-b border-border px-4 py-3 flex items-center gap-3 flex-shrink-0">
        <Button
          variant="ghost"
          size="icon"
          onClick={onCancel}
          className="flex-shrink-0"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div className="flex-1 min-w-0 flex items-center gap-2">
          <CalendarIcon className="h-5 w-5 flex-shrink-0" />
          <h1 className="font-semibold text-lg truncate">
            {title}
          </h1>
        </div>
      </div>

      {/* Form Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <VisitFormContent
          values={values}
          onFieldChange={onFieldChange}
          onSubmit={onSubmit}
          onCancel={onCancel}
          isLoading={isLoading}
          showDeleteButton={showDeleteButton}
          onDelete={onDelete}
          showNoShowButton={showNoShowButton}
          onNoShow={onNoShow}
          currentStatus={currentStatus}
          onCustomerSelect={onCustomerSelect}
          visitServiceIds={visitServiceIds}
          visitTeamMemberIds={visitTeamMemberIds}
          onVisitChange={onVisitChange}
          prefilledCustomer={prefilledCustomer}
          isEditingVisit={isEditingVisit}
        />
      </div>
    </div>
  );
};
